import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'omalonConnecting';
const args = {};

export class OmalonConnecting extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
